import { type RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList'
import { type FC, useCallback } from 'react'
import { useRefinementList } from 'react-instantsearch'
import { useIntl } from 'react-intl'

import {
  ProductSearchRefinementCheckbox,
  type ProductSearchRefinementCheckboxProps,
} from '../ProductSearchRefinementCheckbox'

const PRESCRIPTION_TYPES_COUNT = 2

const transformItems = (
  items: RefinementListItem[],
  intl: ReturnType<typeof useIntl>,
): RefinementListItem[] => {
  return items.map((item) => ({
    ...item,
    label:
      item.label === 'true'
        ? intl.formatMessage({
            id: 'prescription.labels.prescriptionRequired',
          })
        : intl.formatMessage({
            id: 'prescription.labels.noPrescriptionRequired',
          }),
  }))
}

type ProductSearchRefinementPrescriptionTypesProps = Omit<
  ProductSearchRefinementCheckboxProps,
  'transformItems'
>

export const ProductSearchRefinementPrescriptionTypes: FC<
  ProductSearchRefinementPrescriptionTypesProps
> = (props) => {
  const { items } = useRefinementList(props)

  const labels = new Set(items.map((item) => item.label))
  const intl = useIntl()

  const memoizedTransformItems = useCallback(
    (refinementListItems: RefinementListItem[]) =>
      transformItems(refinementListItems, intl),
    [intl],
  )

  if (
    items.length !== PRESCRIPTION_TYPES_COUNT ||
    !labels.has('true') ||
    !labels.has('false')
  ) {
    return null
  }

  return (
    <ProductSearchRefinementCheckbox
      {...props}
      transformItems={memoizedTransformItems}
    />
  )
}
